module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/LEDモジュール.0d7b175d.png";